import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FeesListComponent } from './fees-list/fees-list.component';
import { FeesCreateComponent } from './fees-create/fees-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: FeesListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: FeesCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'fees-create/:id',
        component: FeesCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FeesRoutingModule { }
